/**
 * ICAS role configurations.
 */

import { ICAS_CALENDAR } from './calendars'
import { RoleConfig } from './types'

/**
 * ICAS Provider configuration.
 * International providers with special help center and scheduling.
 */
export const ICAS_PROVIDER: RoleConfig = {
  sameDayBooking: false,
  bcPlatform: false,
  videoSessionsEnabled: false,
  medicationEnabled: false,
  zendeskWidget: false,
  directAccessClientList: true,
  requestPayment: false,
  eligibilityChecker: false,
  showOverdueMessageFlag: false,
  helpCenterUrl: 'https://icas-provider-support.zendesk.com/hc/',
  showInPersonPrompt: false,
  smartSchedulingEnabled: false,
  internationalSmartSchedulingEnabled: true,
  hidePerformanceMetrics: true,
  showCloseSessionBanner: true,
  inProductCalendar: ICAS_CALENDAR,
  showCareInsights: false,
}

/**
 * International Engage therapist configuration.
 * Reuses the legacy ICAS provider settings while enabling BC platform features.
 */
export const ICAS_ENGAGE_THERAPIST: RoleConfig = {
  ...ICAS_PROVIDER,
  bcPlatform: true,
  hideRiskAlerts: true,
}
